import React, { Fragment } from 'react';

export const Layout = props => (
  <Fragment>
    <div>{props.children}</div>
  </Fragment>
);
